var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "tabler-icon-circle-arrow-down-left"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.5 7.16059L7.5 11.9343M7.5 11.9343H12.5M7.5 11.9343V7.16059M2.5 9.54745C2.5 10.4878 2.69399 11.4189 3.0709 12.2877C3.44781 13.1565 4.00026 13.9458 4.6967 14.6108C5.39314 15.2757 6.21993 15.8031 7.12987 16.163C8.03982 16.5228 9.01509 16.708 10 16.708C10.9849 16.708 11.9602 16.5228 12.8701 16.163C13.7801 15.8031 14.6069 15.2757 15.3033 14.6108C15.9997 13.9458 16.5522 13.1565 16.9291 12.2877C17.306 11.4189 17.5 10.4878 17.5 9.54745C17.5 7.64835 16.7098 5.82702 15.3033 4.48415C13.8968 3.14128 11.9891 2.38686 10 2.38686C8.01088 2.38686 6.10322 3.14128 4.6967 4.48415C3.29018 5.82702 2.5 7.64835 2.5 9.54745Z",
    stroke: "#219C3C",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditIcon);
export default __webpack_public_path__ + "static/media/CreditIcon.6038c96a51f414b3c0504f344df1389e.svg";
export { ForwardRef as ReactComponent };